import React from "react";
import ModalSkeleton from "../../atoms/ModalSkeleton/index";
import classes from "./MessageModal.module.css";

export const MessageModal = ({
  showModal = false,
  setShowModal = () => {},
  loading = false,
  data,
}) => {
  return (
    <ModalSkeleton
      show={showModal}
      setShow={setShowModal}
      modalStyles={classes.modal}
      header={"Message"}
      headerClass={classes.header}
      showCloseIcon
      headerHeading={classes.heading}
    >
      <div className={classes.mainDiv}>
        <p>{data?.message}</p>
      </div>
    </ModalSkeleton>
  );
};
